import AbstractComponent from "./abstract-component";

const getCheckboxMarkup = (values) => {
  return Object.values(values)
  .sort((a, b) => Math.sign(+b.count) - Math.sign(+a.count))
  .map((value) => {
    return (
      `<label class="filter__checkbox" data-disabled="${!+value.count}">
        <input class="filter__checkboxInput" type="checkbox" data-id="${value.value}" data-title="${value.title}" ${value.isCheck ? `checked` : ``}>
        <span class="filter__checkboxLabel">${value.title}</span>
        ${+value.count
        ? `<span class="filter__checkboxCount">${value.count}</span>`
        : ``}
      </label>`
    );
  }).join(`\n`);
};

const createTemplate = (title, values, isShowAll) => {
  const checkboxMarkup = getCheckboxMarkup(values);
  return (
    `<fieldset class="filter__item">
      <legend class="filter__itemTitle">${title}</legend>
      <div class="filter__wrap" data-show-all="${isShowAll}">
        ${checkboxMarkup}

        ${!isShowAll && Object.keys(values).length > 5
      ? `<button type="button" class="filter__showAllButton">
          Показать все
          <svg class="" width="10" height="10" aria-hidden="true">
            <use href="sienge/img/sprite.svg#arrow-small"></use>
          </svg>
        </button>`
      : ``}
        
      </div>
    </fieldset>`
  );
};

export default class FilterListComponent extends AbstractComponent {
  constructor({title, alias, values, isShowAll = false}) {
    super();

    this._title = title;
    this._alias = alias;
    this._values = values;
    this._isShowAll = isShowAll;
  }

  getTemplate() {
    return createTemplate(this._title, this._values, this._isShowAll);
  }

  setShowAllButtonClickHandler(handler) {
    const button = this.getElement().querySelector(`.filter__showAllButton`);
    if (!button) {
      return;
    }

    button.addEventListener(`click`, () => {
      this.getElement().querySelector(`.filter__wrap`).dataset.showAll = `true`;
      handler(this._alias);
    });
  }

  setCheckboxChangeHandler(handler) {
    const checkboxes = this.getElement().querySelectorAll(`.filter__checkboxInput`);

    Array.from(checkboxes).forEach((checkbox) => {
      checkbox.addEventListener(`change`, () => {
        const values = Array.from(checkboxes)
            .filter((ch) => ch.checked)
            .map((ch) => {
              return {
                id: ch.dataset.id,
                title: ch.dataset.title,
              };
            });

        handler({
          alias: this._alias,
          title: this._title,
          values,
        },
        checkbox);
      });
    });
  }
}
